import React from 'react'
// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@layouts/utils'
import { Redirect } from 'react-router-dom'

const VerticalMenuNavItems = (props) => {
  // ** Components Object
  const Components = {
    VerticalNavMenuSectionHeader,
    VerticalNavMenuGroup,
    VerticalNavMenuLink
  }
  if(props.items === undefined){
    if(JSON.parse(localStorage.getItem('user')) === null){
      return <Redirect to='/' />
    }
  }
  // ** Render Nav Menu Items
  let RenderNavItems;
 
  RenderNavItems = props?.items && props?.items?.map((item, index) => {
    if(item?.roles?.includes(JSON.parse(window.localStorage.getItem('user'))?.role)){
      const TagName = Components[resolveNavItemComponent(item)]
      return <TagName key={item.id || item.header} item={item} {...props} />
    }
  })
  return RenderNavItems
}

export default VerticalMenuNavItems
